import { CustomFormControl } from 'digital-core';
import { ADPResourceService as ResourceService } from 'digital-core';

export class EmailValidator {
  constructor(public resourceService: ResourceService) {}

  isEmailValid(component: CustomFormControl) {
    if (!component.value) {
      return;
    }

    const value = component.value;

    const emailMatch = value.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]{2,})\.([a-zA-Z]{2,5})$/);

    if (emailMatch && emailMatch.length > 0) {
      return null;
    } else {
      return { validateEmail: { valid: false } };
    }
  }
}
